<template>
    <div class="detailCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-8 col-md-8">

                    <v-text-field color="secondary" label="*Proveedor" placeholder="Ingrese el nombre del proveedor"
                        :counter="40" :maxlength="40" required :rules="nameSupplierRules"
                        v-model="formData.nameSupplier"></v-text-field>

                        <v-select color="secondary" label="*Tipo Identificación"
                        placeholder="Selecciona un tipo de identificación" required :items="typeIdentification"
                        item-text="identificationType" item-value="identificationId" :rules="tipoIdentificacionRules"
                        v-model="formData.identificationId"></v-select>

                    <v-text-field color=secondary label="*Número Identificación"
                        placeholder="Ingrese el número de identificación" required :counter="19" :maxlength="19"
                        :rules="identificationNumberRules" v-model="formData.identificationNumber"
                        @input="formatIdentificationNumber" @keydown="handleKeyDown" inputmode="numeric"></v-text-field>

                    <v-text-field color=secondary label="*Nombre Asesor" placeholder="Ingrese nombre de asesor"
                        :counter="100" :maxlength="100" required :rules="adviserRules"
                        v-model="formData.adviser"></v-text-field>

                    <v-text-field color="secondary" label="*Teléfono" placeholder="Ingrese el número de contacto"
                        required :rules="[...phoneRules, phoneLengthRule]" v-model="formData.contactNumber"
                        @keydown="handleKeyPhoneDown" inputmode="numeric" pattern="[0-9]{0,10}" :counter="15"
                        :maxlength="15"></v-text-field>

                    <v-text-field color=secondary label="*Correo" placeholder="Ingrese un correo" required
                        :rules="emailRules" :counter="200" :maxlength="200" v-model="formData.email"></v-text-field>
                </v-form>

                <div class="image-container">
                    <div>
                        <changeImage :image="this.suppliers.icon" />
                    </div>
                    <div class="img-btn">

                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>Seleccionar una Imagen</span>
                        </v-tooltip>

                        <input type="file" @change="onFileChange" id="file-input" accept="image/*"
                            style="display: none" />

                        <v-tooltip left>

                            <template v-slot:activator="{ attrs }">

                                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs"
                                    @click="submitForm">
                                    <v-icon dark>mdi-content-save</v-icon>
                                </v-btn>

                            </template>

                            <span>Actualizar Proveedor</span>

                        </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";

import {
    SUPPLIERS_M,
    ACTION_PUT_UPDATE_SUPPLIERS,
    GET_STATE_LOADING,
} from "@/views/suppliers/store/types/types.js";

import {
    COMPANIES_M,
    GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT
} from "@/views/companies/store/types/types.js";


import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {
        changeImage,
    },
    name: "detailCompaniesComponent",
    props: {
        suppliers: {
            required: true
        },

    },

    data() {
        return {
            formData: {
                supplierId: this.suppliers.supplierId,
                nameSupplier: this.suppliers.nameSupplier,
                adviser: this.suppliers.adviser,
                identificationId: this.suppliers.identification.identificationId,
                identificationType: this.suppliers.identification.identificationType,
                identificationNumber: this.suppliers.identificationNumber,
                contactNumber: this.suppliers.contactNumber,
                email: this.suppliers.email,
                imageFile: this.suppliers.icon,
            },

            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],
            rules: [value => !!value || "Campo requerido.",],

            nameSupplierRules: [
                v => !!v || "Proveedor requerido",
                v => (v && v.length <= 40) || "El nombre no puede tener más de 40 caracteres",
            ],
            tipoIdentificacionRules: [
                v => !!v || "Tipo identificación requerido"
            ],
            identificationNumberRules: [
                v => !!v || "Número identificación requerido"
            ],
            adviserRules: [
                v => !!v || "Nombre asesor requerido",
                v => (v && v.length <= 100) || "Nombre asesor no puede tener más de 100 caracteres",
            ],
            phoneRules: [
                v => !!v || "Teléfono requerido",
            ],
            phoneLengthRule: v =>
                (v && v.length >= 7 && v.length <= 15) || "Teléfono debe tener entre 7 y 15 dígitos",

            emailRules: [
                v => !!v || "Correo requerido",
                v => (v && v.length <= 200) || "Correo no puede tener más de 200 caracteres",
                v => emailRegex.test(v) || "El formato del correo es inválido"
            ],

            showErrorMessages: false,
            emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            suppliersUpdate: null,
        };
    },

    async mounted() {
        this.getActionTypeIdentification();
    },

    computed: {
        ...mapGetters({
            loading: [`${SUPPLIERS_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${COMPANIES_M}${GET_COMPANIES_LIST_TYPE_DOCUMENT}`]
        }),
        imageUrl() {
            return this.formData.imageFile;
        },
    },

    methods: {

        ...mapActions({
            putActionUpdateSuppliers: `${SUPPLIERS_M}${ACTION_PUT_UPDATE_SUPPLIERS}`,
            getActionTypeIdentification: `${COMPANIES_M}${ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT}`
        }),

        handleKeyDown(event) {
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        handleKeyPhoneDown(event) {
            const allowedKeys = /^[0-9()-]$/;
            if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },
   
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.formData.imageFile = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.suppliers.icon = e.target.result;
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.imageFile.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
                });
            }
        },

        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    const update = await this.putActionUpdateSuppliers(this.formData);
                    EventBus.$emit('reload-update-suppliers');
                    if (!update) {
                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        });
                    }
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error("Fallo al actualizar", error);
            }
        },

        formatIdentificationNumber() {
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');
            let formattedNumber = '';
            while (number.length > 0) {
                formattedNumber = number.slice(-3) + formattedNumber;
                number = number.slice(0, -3);
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;
            const notOnlyWhitespaceRegex = /\S/;

            const errors = {};

            if (!this.formData.nameSupplier || !this.formData.nameSupplier.trim() || this.formData.nameSupplier.length > 40) {
                errors.nameSupplier = 'Proveedor';
            }

            if (!this.formData.identificationId) {
                errors.identificationId = 'Tipo Identificación';
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = 'Número Identificación';
            }

            if (!this.formData.adviser || !notOnlyWhitespaceRegex.test(this.formData.adviser) || this.formData.adviser.length > 100) {
                errors.adviser = 'Nombre Asesor';
            }

            if (!this.formData.contactNumber || !/^[0-9\s()-]{7,15}$/.test(this.formData.contactNumber)) {
                errors.contactNumber = 'Teléfono';
            }

            if (!this.formData.email || !emailRegex.test(this.formData.email) || this.formData.email.length > 50) {
                errors.email = 'Correo';
            }

            if (!this.formData.imageFile) {
                errors.imageFile = 'Logo';
            }

            return errors;
        },
    },
};

</script>

<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* Alineación vertical */
}

.img-btn {
    margin-top: 20px;
    /* Espacio entre el componente changeImage y el botón de seleccionar imagen */
}

.user-btn {
    position: absolute;
    top: 20px;
    /* Posicionamiento en la parte superior */
    right: 20px;
    /* Posicionamiento a la derecha */
}

/*Resposive*/

@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .image-container {
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .col-md-7 {
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }

    .user-btn {
        position: static;
        margin-top: 20px;
    }
}
</style>